import InfoTooltip from 'Components/InfoTooltip'
import { Typography } from '@mui/material'
import { t } from 'ttag'

function MaximumDeviceTransfersTooltip() {
  return (
    <InfoTooltip
      title={
        <Typography variant="body2">
          {t`How many times the ticket can be transferred from one phone to another.`}
        </Typography>
      }
    />
  )
}

export default MaximumDeviceTransfersTooltip
